// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h9-a";
export var fulfillmentFormRail = "_h9-9";
export var headerTitleRow = "_h9-c";
export var orderDetailsWrapper = "_h9-7";
export var orderLinkTrigger = "_h9-2";
export var paymentInformationGrid = "_h9-h";
export var paymentSummaryColumn = "_h9-i";
export var shipmentContainer = "_h9-b";
export var shipmentDetailsMainPane = "_h9-8";
export var shipmentNavigationCard = "_h9-5";
export var shipmentNavigationRail = "_h9-3";
export var shipmentNavigationRailHeader = "_h9-4";
export var shipmentSummaryFact = "_h9-e";
export var shipmentSummaryGrid = "_h9-d";
export var shipmentSummaryMetadataRow = "_h9-f";
export var shipmentSummaryTags = "_h9-g";
export var shipmentWorkspace = "_h9-0";
export var shipmentWorkspaceContent = "_h9-6";
export var shipmentWorkspaceHeader = "_h9-1";